import React, { useEffect, useState } from "react";
import ApiCall from "../../utils/apicall";
import {
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
  TablePagination,
} from "@mui/material";
import Iconify from "../../components/iconify";

import SmartTable from "../SmartTable/SmartTable";
function CallList() {
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  useEffect(() => {
    const fetchPhoneNumbers = async () => {
      try {
        const response = await ApiCall.get("/user");
        setPhoneNumbers(response.data.data.users || []);
      } catch (error) {
        console.error("Error fetching phone numbers:", error);
      }
    };

    fetchPhoneNumbers();
  }, []);

  const handleCall = (phoneNumber) => {
    const whatsappUrl = `https://wa.me/${phoneNumber}`;
    window.open(whatsappUrl, "_blank");
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          width: "100%",
          flexDirection: "column",
          alignItems: "center",
          background: "#2065D1",
          borderRadius: 10,
          color: "white",
          marginBottom: "20px",
        }}
      >
        <p>Number List</p>
      </div>
      {phoneNumbers.length === 0 ? (
        <p>No phone numbers available for calling.</p>
      ) : (
        <>
          <TableContainer>
            <SmartTable tableId="call-list" lockedColumns={["First Name", "Last Name"]}>
              <TableHead>
                <TableRow>
                  <TableCell>First Name</TableCell>
                  <TableCell>Last Name</TableCell>
                  <TableCell>Phone Number</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {phoneNumbers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.firstName}</TableCell>
                      <TableCell>{item.lastName}</TableCell>
                      <TableCell>{item.phone}</TableCell>
                      <TableCell>
                        <Button onClick={() => handleCall(item.phone)}>
                          <Iconify icon="logos:whatsapp-icon" />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </SmartTable>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5]}
            component="div"
            count={phoneNumbers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      )}
    </div>
  );
}

export default CallList;
